import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import React, { useEffect, useState } from 'react';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ThemeProvider } from 'styled-components';
import ProtectedRoute from './components/utilities/protectedRoute';
import config from './config/config';
// import store from './redux/store';
import { store } from './stores/store';

import Admin from './routes/admin';
import Auth from './routes/auth';
import './static/css/style.css';

// Create a client
const queryClient = new QueryClient();
// const NotFound = lazy(() => import('./container/pages/404'));

const { themeColor } = config;

function ProviderConfig() {
  const { rtl, isLoggedIn, topMenu, mainContent } = useSelector((state) => {
    return {
      rtl: state.ThemeLayout.rtlData,
      topMenu: state.ThemeLayout.topMenu,
      mainContent: state.ThemeLayout.mode,
      isLoggedIn: state.Auth.logedIn,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    return () => {
      unmounted = true;
    };
  }, [setPath]);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent }}>
        <>
          <Router basename={process.env.PUBLIC_URL}>
            {!isLoggedIn ? (
              <Routes>
                <Route path="/*" element={<Auth />} />{' '}
              </Routes>
            ) : (
              <Routes>
                <Route path="/system/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
                <Route path="/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
                {/* <Route path="*" element={<NotFound />} /> */}
              </Routes>
            )}
            {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
              <Routes>
                <Route path="/" element={<Navigate to="/system" />} />
              </Routes>
            )}
          </Router>
        </>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ProviderConfig />
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
